import firebase from 'firebase'
import 'firebase/storage'

export const config = {
  apiKey: 'AIzaSyDBST06fceRJU0ghc9ggj9B6xXgSItqn-E',
  authDomain: 'bagnall-hill.firebaseapp.com',
  databaseURL: 'https://bagnall-hill.firebaseio.com',
  projectId: 'bagnall-hill',
  storageBucket: 'bagnall-hill.appspot.com',
  messagingSenderId: '752013025694',
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

export const database = firebase.database()
export const storage = firebase.storage()
export const authorize = firebase.auth()

export const adminUpdate = (url, obj, success, cb, cbUrl) => {
  database.ref(url).set(obj).then(() => {
    success(cb, cbUrl)
  }).catch(() => {
    alert('Oops, it didn\'t work...')
  })
}

export const adminCreate = (url, obj, success, cb, cbUrl) => {
  database.ref(url).set(obj).then(() => {
    success(cb, cbUrl)
  }).catch(() => {
    alert('Oops, it didn\'t work...')
  })
}

export const adminRemove = (url, success, cb, cbUrl) => {
  database.ref(url).remove().then(() => {
    success(cb, cbUrl)
  }).catch(() => {
    alert('Oops, it didn\'t work...')
  })
}

export const auth = {
  authenticate (email, password, cb) {
    authorize.signInWithEmailAndPassword(email, password)
      .then(() => {
        cb()
      })
      .catch(() => {
        alert('Incorrect details')
      })
  },
  signout (cb) {
    authorize.signOut().then(() => {
      cb()
    }).catch(() => {
      alert('Oops, something went wrong.')
    })
  },
}



// WEBPACK FOOTER //
// /opt/build/repo/src/firebase.js